import cx from 'classnames';
import type { ElementType, HTMLAttributes } from 'react';
import css from './Card.module.scss';

interface ICardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

interface ITitleProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

const Card = ({
  as: Component = 'div',
  children,
  className,
  ...rest
}: ICardProps) => (
  <Component className={cx(css.card, className)} {...rest}>
    {children}
  </Component>
);

const Title = ({
  as: Component = 'h2',
  children,
  className,
  ...rest
}: ITitleProps) => (
  <Component className={cx(css.title, className)} {...rest}>
    {children}
  </Component>
);

Card.Title = Title;

export { Card };
export type { ICardProps, ITitleProps as ICardTitleProps };
